import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative flex flex-col gap-4 rounded-xl border border-white/5 bg-gradient-to-br from-white/5 to-white/10 p-4 transition-all hover:bg-white/5" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-start justify-between gap-4"
}
const _hoisted_3 = {
  key: 0,
  class: "flex-1 min-w-0"
}
const _hoisted_4 = {
  key: 1,
  class: "flex shrink-0 items-center gap-2"
}
const _hoisted_5 = {
  key: 1,
  class: "flex flex-col gap-4"
}
const _hoisted_6 = {
  key: 2,
  class: "border-t border-white/5 pt-4 mt-2"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileCard',
  setup(__props) {

// Mobile Card Component

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$slots.header || _ctx.$slots.actions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.$slots.header)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "header")
              ]))
            : _createCommentVNode("", true),
          (_ctx.$slots.actions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _renderSlot(_ctx.$slots, "actions")
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.$slots.content)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "content")
        ]))
      : _createCommentVNode("", true),
    (_ctx.$slots.footer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "footer")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})